import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchWhatsNewFailure, fetchWhatsNewSuccess } from "domains/whatsNew/actions";
import type { WhatsNewPayload } from "domains/whatsNew/types";

export function* fetchWhatsNewSaga() {
  try {
    const marketingPackage: WhatsNewPayload = yield apiFetch("marketing_package");
    yield put(fetchWhatsNewSuccess(marketingPackage));
  } catch {
    yield put(fetchWhatsNewFailure());
  }
}
